// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICustomPageable } from './ICustomPageable';
import {
    ICustomPageableFromJSON,
    ICustomPageableFromJSONTyped,
    ICustomPageableToJSON,
    ICustomPageableToJSONTyped,
} from './ICustomPageable';
import type { IEmployeeEmployerInfoDto } from './IEmployeeEmployerInfoDto';
import {
    IEmployeeEmployerInfoDtoFromJSON,
    IEmployeeEmployerInfoDtoFromJSONTyped,
    IEmployeeEmployerInfoDtoToJSON,
    IEmployeeEmployerInfoDtoToJSONTyped,
} from './IEmployeeEmployerInfoDto';

/**
 * 
 * @export
 * @interface ICustomPageEmployeeEmployerInfoDto
 */
export interface ICustomPageEmployeeEmployerInfoDto {
    /**
     * 
     * @type {number}
     * @memberof ICustomPageEmployeeEmployerInfoDto
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageEmployeeEmployerInfoDto
     */
    size?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageEmployeeEmployerInfoDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageEmployeeEmployerInfoDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageEmployeeEmployerInfoDto
     */
    empty?: boolean;
    /**
     * 
     * @type {Array<IEmployeeEmployerInfoDto>}
     * @memberof ICustomPageEmployeeEmployerInfoDto
     */
    content?: Array<IEmployeeEmployerInfoDto>;
    /**
     * 
     * @type {ICustomPageable}
     * @memberof ICustomPageEmployeeEmployerInfoDto
     */
    pageable?: ICustomPageable;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageEmployeeEmployerInfoDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageEmployeeEmployerInfoDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageEmployeeEmployerInfoDto
     */
    total_elements?: number;
}

/**
 * Check if a given object implements the ICustomPageEmployeeEmployerInfoDto interface.
 */
export function instanceOfICustomPageEmployeeEmployerInfoDto(value: object): value is ICustomPageEmployeeEmployerInfoDto {
    return true;
}

export function ICustomPageEmployeeEmployerInfoDtoFromJSON(json: any): ICustomPageEmployeeEmployerInfoDto {
    return ICustomPageEmployeeEmployerInfoDtoFromJSONTyped(json, false);
}

export function ICustomPageEmployeeEmployerInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICustomPageEmployeeEmployerInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'] == null ? undefined : json['number'],
        'size': json['size'] == null ? undefined : json['size'],
        'last': json['last'] == null ? undefined : json['last'],
        'first': json['first'] == null ? undefined : json['first'],
        'empty': json['empty'] == null ? undefined : json['empty'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IEmployeeEmployerInfoDtoFromJSON)),
        'pageable': json['pageable'] == null ? undefined : ICustomPageableFromJSON(json['pageable']),
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
    };
}

export function ICustomPageEmployeeEmployerInfoDtoToJSON(json: any): ICustomPageEmployeeEmployerInfoDto {
    return ICustomPageEmployeeEmployerInfoDtoToJSONTyped(json, false);
}

export function ICustomPageEmployeeEmployerInfoDtoToJSONTyped(value?: ICustomPageEmployeeEmployerInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'last': value['last'],
        'first': value['first'],
        'empty': value['empty'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IEmployeeEmployerInfoDtoToJSON)),
        'pageable': ICustomPageableToJSON(value['pageable']),
        'totalPages': value['total_pages'],
        'numberOfElements': value['number_of_elements'],
        'totalElements': value['total_elements'],
    };
}

